import React from 'react';
import {
  TextContainer,
  SkeletonDisplayText,
  SkeletonBodyText,
} from '@shopify/polaris';
import {SkeletonReviewListing} from 'sections/services-marketplace/experts/components';

import * as styles from './Reviews.scss';

export function SkeletonReviews() {
  return (
    <div className={styles.Container}>
      <div className={styles.Header}>
        <TextContainer>
          <SkeletonDisplayText size="large" />
        </TextContainer>
      </div>
      <div className={styles.RatingAggregate}>
        <TextContainer>
          <SkeletonBodyText lines={5} />
        </TextContainer>
      </div>
      <div className={styles.ReviewListings}>
        {[...Array(4).keys()].map(key => (
          <SkeletonReviewListing key={key} />
        ))}
      </div>
    </div>
  );
}
